export default class ECSAttributionApply {
  // Function to handle attribution updates to contact forms
  contactFormAttribution (_lead, _providerUtils, _settings) {
    const $contactForms = $('form[data-ecs-attribution-form]')
    // Bind event for all applicable form submit events
    $contactForms.each(function () {
      $(this).on('submit', function () {
        // Get all the forms elements and their values in one step
        var values = $(this).serializeArray()
        var data = {}
        $(values).each(function (index, obj) {
          data[obj.name] = obj.value
        })

        _providerUtils.onFormSubmit(data, _lead)
      })
    })
  }

  // Function to handle attribution updates to email links
  emailLinkAttribution (_lead) {
    const emailLinks = jQuery('a[data-ecs-attribution-email]')

    emailLinks.each(function () {
      const originalVal = jQuery(this).attr('href')
      const originalText = jQuery(this).text()
      const emailRegEx = new RegExp('/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi')
      $(this).attr('href', 'mailto:' + _lead.attribution.email.email)
      $(this).attr('ecs-attributions-email-originalhref', originalVal)
      $(this).attr('ecs-attributions-email-originaltext', originalText)
    })

    if (emailRegEx.test(originalText)) {
      $(this).text(_lead.attribution.email.email)
    }
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return null
  }

  // Function to handle attribution updates to phone links
  phoneLinkAttribution (_lead) {
    const utility = this
    const phoneLinks = jQuery('a[data-ecs-attribution-phone]')

    phoneLinks.each(function () {
      const originalVal = jQuery(this).attr('href')
      const originalText = jQuery(this).text()
      const phoneRegEx = new RegExp(/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/)
      $(this).attr('href', 'tel:' + _lead.attribution.phone.dniPhone)
      $(this).attr('ecs-attributions-phone-originalhref', originalVal)
      $(this).attr('ecs-attributions-phone-originaltext', originalText)

      if (phoneRegEx.test(originalText)) {
        $(this).text(utility.formatPhoneNumber(_lead.attribution.phone.dniPhone))
      }
    })
  }

  // Function to handle attribution updates to apply links
  leasingLinkAttribution (_lead) {
    const leasingLinks = jQuery('[ecs-attribution-leasing]')
  }

  applyAttribution (_pluginSettings, _lead, _providerUtils) {
    if (_pluginSettings.disabled_tasks.phone == 0 && _lead.attribution.phone != undefined) {
      this.phoneLinkAttribution(_lead)
    }

    if (_pluginSettings.disabled_tasks.email == 0 && _lead.attribution.email != undefined) {
      this.emailLinkAttribution(_lead)
    }

    if (_pluginSettings.disabled_tasks.email == 0) {
      this.contactFormAttribution(_lead, _providerUtils, _pluginSettings)
    }

    // if (_pluginSettings.disabled_tasks.lead != 0) {
    //   this.leasingLinkAttribution(_lead)
    // }
  }
}
